import styled from "styled-components";

const ListWrapper = styled.div`
    width:30%;

    @media (max-width:1100px){
        width:40%;
    }
    @media (max-width:768px) {
        width:90%;
    }
`
export default ListWrapper;